import HttpClient from "@/services/HttpClient";
import { EServices } from "@/types";
import IJsonResponse from "@/utils/types/IJsonResponse";
import { inject, injectable } from "tsyringe";

@injectable()
export default class ComplaintsClient {
  constructor(@inject(EServices.http) private http: HttpClient) {}

  async createComplaints(
    transactionId: string,
    blockchainTransactionHash: string,
    description?: string,
    additionalDetails?: string
  ): Promise<IJsonResponse> {
    const response = await this.http.post("/v1/app/compliants", {
      transactionId,
      blockchainTransactionHash,
      description,
      additionalDetails,
    });
    return response;
  }
}
